module.exports = __webpack_public_path__ + "static/media/plumbing-logo.7d237104.jpg";